export const environment = {
  backendUrl: 'https://api.colmec.se/',
  production: true,
  analyticsId: 'UA-167348555-1',
  quoteConfirmationEmailAddress: 'webshop@colmec.se',
  enableClaim: true
};
